var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiloDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1690_42665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6777 8.7922L14.2682 21.7412C14.1637 21.8415 14.0245 21.8975 13.8797 21.8975C13.7349 21.8975 13.5957 21.8415 13.4912 21.7412L1.08172 8.7922C0.982864 8.69134 0.92749 8.55575 0.92749 8.41452C0.92749 8.27329 0.982864 8.13769 1.08172 8.03684L4.31898 4.79958C4.42192 4.69629 4.56163 4.63807 4.70746 4.63771C4.78052 4.63868 4.85263 4.65449 4.91941 4.68417C4.98619 4.71385 5.04624 4.75678 5.09593 4.81037L13.8797 14.1013L22.6635 4.79958C22.7132 4.74599 22.7732 4.70306 22.84 4.67338C22.9068 4.6437 22.9789 4.62789 23.0519 4.62692C23.1943 4.62895 23.33 4.68713 23.4296 4.78878L26.6669 8.02605C26.7182 8.07549 26.7591 8.1346 26.7875 8.19996C26.8158 8.26532 26.8309 8.33565 26.8319 8.40687C26.8329 8.4781 26.8198 8.54882 26.7933 8.61496C26.7668 8.68109 26.7275 8.74133 26.6777 8.7922Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1690_42665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8981,
    height: 25.8981,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.93042 26.2212)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloDownArrow);
export default __webpack_public_path__ + "static/media/hilo-down-arrow.267ee358455fceca44e3b99214cdf990.svg";
export { ForwardRef as ReactComponent };